export default "__VITE_ASSET__2LpuLJVP__"